// extracted by mini-css-extract-plugin
module.exports = {"wrapperInner":"Message-module--wrapperInner--3M4vq","button":"Message-module--button--58b2I"};